import { FeaturePageVisual } from "@/features/feature-page/feature-page-visual";
import { cn } from "@/lib/utils";
import type { ResolvedFeaturePageVisual } from "@garimpa/api/featurePages/types";
import type { FeaturePageBackground } from "@garimpa/lib/featurePage";

const overlayClasses = {
  light: "from-background/30 via-background/50 to-background/85",
  medium: "from-background/50 via-background/75 to-background/95",
  strong: "from-background/70 via-background/90 to-background",
} as const;

export function FeaturePageBackground({
  spec,
  visual,
  priority = false,
}: {
  spec: FeaturePageBackground;
  visual: ResolvedFeaturePageVisual;
  priority?: boolean;
}) {
  const focalPoint = spec.focalPoint ?? { x: 0.5, y: 0.5 };
  const className = cn(
    "absolute inset-0 h-full w-full",
    spec.treatment === "contained" ? "object-contain" : "object-cover",
    spec.treatment === "blurredCover" && "scale-110 blur-xl",
  );
  const style = { objectPosition: `${focalPoint.x * 100}% ${focalPoint.y * 100}%` };
  return (
    <div className="pointer-events-none absolute inset-0 z-0 overflow-hidden" aria-hidden="true">
      <FeaturePageVisual
        visual={visual}
        decorative
        priority={priority}
        sizes="100vw"
        className={className}
        style={style}
      />
      <div className={cn("absolute inset-0 bg-gradient-to-b", overlayClasses[spec.overlay])} />
    </div>
  );
}
